<template>
  <div>
    <ModalSuper />

    <ModalCrawler />
    <ModalFetcher />
    <ModalMonitor />
    <ModalSpawner />

    <ModalCrawlerGroup />
    <ModalFetcherGroup />
    <ModalMonitorGroup />
    <ModalSpawnerGroup />
  </div>
</template>

<script>
export default {
  components: {
    ModalSuper: () => import('@/components/admin/Super'),

    ModalCrawler: () => import('@/components/admin/crawler/modals/Super'),
    ModalFetcher: () => import('@/components/admin/fetcher/modals/Super'),
    ModalMonitor: () => import('@/components/admin/monitor/modals/Super'),
    ModalSpawner: () => import('@/components/admin/spawner/modals/Super'),

    ModalCrawlerGroup: () => import('@/components/admin/crawler/modals/Modals'),
    ModalFetcherGroup: () => import('@/components/admin/fetcher/modals/Modals'),
    ModalMonitorGroup: () => import('@/components/admin/monitor/modals/Modals'),
    ModalSpawnerGroup: () => import('@/components/admin/spawner/modals/Modals'),
  },
};
</script>
